import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgAlertError: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 102 102" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#404040" cx={51} cy={51} r={51} />
      <rect fill="#FFF" transform="rotate(45 51 50)" x={46} y={27} width={10} height={46} rx={1} />
      <rect fill="#FFF" transform="scale(-1 1) rotate(45 0 -73.12)" x={46} y={27} width={10} height={46} rx={1} />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgAlertError;
